<template>
  <div class="tile shadow" :class="[{ 'double-border': doubleBorder }]">
    <div class="top-left p-3" style="position: relative">
      <slot name="icon"></slot>
    </div>
    <div class="top-right d-flex align-items-start justify-content-end">
      <slot name="action-buttons"></slot>
    </div>
    <div class="bottom mx-3 mb-3">
      <div class="line">
        <strong>
          <slot name="line1"></slot>
        </strong>
      </div>
      <div class="line small-text text-black-50">
        <slot name="line2"></slot>
      </div>
      <div class="line small-text text-black-50">
        <slot name="line3"></slot>
      </div>
      <div class="line small-text text-black-50">
        <slot name="line4"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tile',
  props: {
    doubleBorder: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  methods: {
    tileClicked() {
      this.$emit('tileClicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.tile {
  border-radius: 10%;
  cursor: pointer;
  background-color: white;
  display: grid;
  align-content: stretch;
  grid-template-columns: 50% 50%;
  grid-template-rows: 50% 50%;
}

.top-left {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  place-self: center;
  align-self: center;
}

.top-right {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

.bottom {
  grid-column: 1 / span 2;
  grid-row: 2 / 3;
  align-self: start;
  .line {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.double-border {
  border: 5px double #c9c9ce;
  border-left: none;
  border-top: none;
}

@media (max-width: 440px) {
  .small-text {
    font-size: 75%;
  }
}
</style>
